import connect from '../axios/axios.auth';

const sucursalFunction =  {
  registro: (data) => {
    return new Promise((resolve) => {
      connect.post(`/sucursal`, data)
      .then((response) => {
        resolve(response);
      })
    })
  },
  userUpdate: (data) => {
    return new Promise((resolve) => {
      connect.put(`/sucursal/usuario`, data)
      .then((response) => {
        resolve(response);
      })
    })
  },
  listado: () => {
    return new Promise((resolve) => {
      connect.get(`/sucursal`)
      .then((response) => {
        resolve(response);
      })
    })
  },
  modificar: (data) => {
    return new Promise((resolve, reject) => {
      connect.put(`/sucursal`, data)
      .then((response) => {
        resolve(response);
      })
    })
  },
  filtro: (data) => {
    return new Promise((resolve, reject) => {
      connect.post(`/sucursal/filtro`, data)
      .then((response) => {
        resolve(response);
      })
    })
  },
  password: (length = 8) => {
    let result = '';
    let chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for (var i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
    return result;
  },
  usuario: (data) => {
    return new Promise((resolve, reject) => {
      connect.post(`/sucursal/usuario`, data)
      .then((response) => {
        resolve(response);
      })
    })
  },
  listadoUsuarios: (data) => {
    return new Promise((resolve, reject) => {
      connect.post(`/sucursal/usuarios`, data)
      .then((response) => {
        resolve(response.data);
      })
    })
  },
  activar: (data) => {
    return new Promise((resolve, reject) => {
      connect.post(`/sucursal/activar`, data)
      .then((response) => {
        resolve(response.data);
      })
    })
  },
  changeStatus: (list, id) => {
    const index = list.findIndex((e) => e.id === id);
    const actualValue = list[index].status;
    list[index].status = actualValue ? 0 : 1;
    return list;
  }
}

export default sucursalFunction;